import { useState, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { useCacheBuster } from 'react-cache-buster';
// mui
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import FormControlLabel from '@mui/material/FormControlLabel';
// components
import SFMessageIcon from '@/component/icons/sf-message-icon';
import SFCloseIcon from '@/component/icons/sf-close-icon';
import SFUnlockIcon from '@/component/icons/sf-unlock-icon';
import AuthPageBanner from '@/component/common/auth-page-banner';
import SFSquareCheckbox from '@/component/common/sf-square-checkbox';
import ArrowLinkButton from '@/component/common/arrow-link-button';
import LoginOtherDrawer from '@/component/auth/login-other-drawer';
import PasswordTextField from '@/component/common/password-textfield';
import SendMobileDrawer from '@/component/auth/send-mobile.drawer';
import { loginCheck } from '@/component/users/login';
import { keepEmail } from '@/component/users/common/keepEmail';
import SocialLoginButtons from '@/component/common/socialLoginButtons';
// lib & etc
import { fontWeight } from '@/theme';
import { localSetStorage, loginLocalStorage } from '@/lib/storage';
import { SFPalette } from '@/lib/color';
import packageJson from '../../../package.json';
// api
import ErrorRes from '@/api/server/ErrorRes';
import { updatePushToken } from '@/api/server/user/update';
// store
import { useAuthInfoActions } from '@/store/zustand/store';
import { snsLogin } from '@/api/server/user/read';
// import { Web3Auth } from '@web3auth/modal';
type FormDataType = {
  email: string;
  password: string;
};

export default function SignInEmail() {
  const { t } = useTranslation();
  const version = packageJson.version;
  const navigate = useNavigate();
  const [keepId, setKeepId] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  const [openSendMobileDrawer, setOpenSendMobileDrawer] = useState(false);
  const { handleSubmit, control, watch, setValue } = useForm<FormDataType>();
  // const { checkCacheStatus } = useCacheBuster();

  // useEffect(() => {
  //   if (process.env.NODE_ENV === 'production' && version !== '2.0.13') {
  //     console.log(`11111111111111111111111111111111`);
  //     window.location.reload();
  //   }

  //   return () => {};
  // }, []);

  // useEffect(() => {
  //   if (isConnected) {
  //     console.log(`isSuccess`);
  //     console.log(connector?.options.web3AuthInstance);
  //     if (connector?.options.web3AuthInstance) {
  //       (async () => {
  //         const web3Auth = connector?.options.web3AuthInstance;
  //         const { idToken } = await web3Auth.getUserInfo();
  //         const paylaod = {
  //           key: 'auth',
  //           value: {
  //             auth: String(idToken),
  //             point: null,
  //           },
  //         };
  //         const re = await snsLogin();
  //         console.log(re);
  //         dispatch(setAuthInfo({ auth: paylaod.value.auth, point: '', date: '' }));
  //         localSetStorage(paylaod);
  //         navigate('/wallet');
  //       })();
  //     }
  //   }
  //   return () => {};
  // }, [isConnected]);

  useEffect(() => {
    // disconnect();
    const re = loginLocalStorage();
    if (!re) {
      return;
    }
    setKeepId(re.keep);
    if (re.keep && re.auth === 'email') {
      setValue('email', re.email);
      // 한 번 로그인 한 상태? 로그인 실패하면?
    }
    return () => {};
  }, []);

  const { setAuthInfo } = useAuthInfoActions();

  const onSubmit = async (aData: FormDataType) => {
    const { email, password } = aData;

    const payload = {
      email,
      user_pw: password,
      keep_login: '',
    };
    const type = 'email' as const;
    const re = await loginCheck({ payload, type });
    if (re.code === 490) {
      // 휴면 계정
      setOpenSendMobileDrawer(true);
      return;
    } else if (re.code !== 200) {
      ErrorRes({ code: re.code, msg: re.msg, path: 'SignIn', isBack: false });
      return;
    }
    if (!re.data) {
      // navigate('/wallet');
      return;
    }
    // checkCacheStatus();
    updatePushToken();
    setAuthInfo(re!.data.value);
    keepEmail(email, keepId, 'email');
    localSetStorage(re!.data);
    navigate('/wallet');
  };

  return (
    <>
      <Container maxWidth="sm">
        <Box pt={4}>
          <AuthPageBanner />
          <form onSubmit={handleSubmit(onSubmit)}>
            <Controller
              name="email"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="standard"
                  placeholder={t('placeholder.inputYourId')}
                  InputProps={{
                    sx: {
                      height: 48,
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <SFMessageIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => {
                            setValue('email', ''); // 이메일 값을 지워준다.
                          }}
                        >
                          <SFCloseIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />

            <Controller
              name="password"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <PasswordTextField
                  {...field}
                  fullWidth
                  placeholder={t('placeholder.inputUourPw')}
                  variant="standard"
                  InputProps={{
                    sx: {
                      height: 48,
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <SFUnlockIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
            {/* TODO 로직 적용 */}
            <Stack direction="row" justifyContent="space-between" mt={2} mb={4}>
              {/* <FormControlLabel
                control={<SFSquareCheckbox color="primary" />}
                label={<Typography variant="body2">로그인 유지</Typography>}
              /> */}
              <FormControlLabel
                checked={keepId}
                control={<SFSquareCheckbox color="primary" />}
                label={<Typography variant="body2">{t('validation.saveId')} </Typography>}
                onChange={() => {
                  setKeepId((prev) => !prev);
                }}
              />
            </Stack>

            <Box mb={2.5}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                size="large"
                sx={{
                  borderRadius: '100px !important',
                }}
                fullWidth
              >
                <Typography variant="h6" fontWeight={fontWeight.Bold}>
                  {t('button.login')}
                </Typography>
              </Button>
            </Box>
          </form>
          <Stack direction="row" alignItems="center" justifyContent="center" gap={2.5} mb={5}>
            <NavLink
              to="/signInSns"
              style={{
                textDecoration: 'none',
              }}
            >
              <Typography variant="body2" color={SFPalette.grey4}>
                {t('button.backwards')}
              </Typography>
            </NavLink>
            <Box height={12} width={'1px'} bgcolor={SFPalette.lightGrey1} />
            {/* <NavLink
              to="/agreeTerms"
              style={{
                textDecoration: 'none',
              }}
            >
              <Typography variant="body2" color={SFPalette.grey4}>
                {t('button.siginUp')}
              </Typography>
            </NavLink>
            <Box height={12} width={'1px'} bgcolor={SFPalette.lightGrey1} /> */}
            <NavLink
              to="/findPw"
              style={{
                textDecoration: 'none',
              }}
            >
              <Typography variant="body2" color={SFPalette.grey4}>
                {t('button.findIdPw')}
              </Typography>
            </NavLink>
          </Stack>
          <Box sx={{ textAlign: 'center' }}>※ 이메일 ID는 기존 회원만 이용 가능합니다.</Box>
        </Box>

        <LoginOtherDrawer
          open={openDrawer}
          onClose={() => {
            setOpenDrawer(false);
          }}
        />
        <SendMobileDrawer open={openSendMobileDrawer} onClose={() => setOpenSendMobileDrawer(false)} />
      </Container>
    </>
  );
}
